import { Anchor } from '@/components/client/seo/anchor'
import { tw } from '@/lib/utils'

export interface ScorecardLearnMoreTracking {
  seller: string
  sellerType: string
  release: string
  /** Where on the page the CTA sits, for analytics. */
  position: string
}

interface ScorecardLearnMoreProps {
  url: string
  /** Visible button text, e.g. "Learn more at Zip Hearing". */
  label: string
  /** Stable CTA identifier for analytics when the visible label varies per seller. Defaults to `label`. */
  cta?: string
  tracking: ScorecardLearnMoreTracking
  className?: string
}

const ExternalLinkIcon = () => (
  <svg width="14" height="14" viewBox="0 0 512 512" fill="currentColor" className="flex-shrink-0">
    <path d="M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l82.7 0-201.4 201.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3 448 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160c0-17.7-14.3-32-32-32L320 0zM80 96C35.8 96 0 131.8 0 176L0 432c0 44.2 35.8 80 80 80l256 0c44.2 0 80-35.8 80-80l0-80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 80c0 8.8-7.2 16-16 16L80 448c-8.8 0-16-7.2-16-16l0-256c0-8.8-7.2-16 16-16l80 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 96z" />
  </svg>
)

/** The scorecard's primary-offer CTA (tracked click + impression). */
export const ScorecardLearnMore = ({ url, label, cta, tracking, className }: ScorecardLearnMoreProps) => (
  <Anchor
    href={url}
    target="_blank"
    rel="noopener noreferrer nofollow"
    data-track
    data-track-impression
    data-event-name="AffiliateAction"
    data-event-seller={tracking.seller}
    data-affiliate-seller-type={tracking.sellerType}
    data-event-product={tracking.release}
    data-event-position={tracking.position}
    data-affiliate-cta={cta ?? label}
    data-affiliate-text={label}
    data-affiliate-test-name="product-scorecard"
    data-event-url={url}
    className={tw(
      'bg-lapis hover:bg-navy min-h-[48px] items-center justify-center gap-1.5 rounded-xl px-4 text-center text-sm font-bold text-white shadow-sm transition-all duration-150 hover:shadow-md active:scale-[0.97]',
      className
    )}
  >
    {label}
    <ExternalLinkIcon />
  </Anchor>
)
